import React, { useState } from "react";
import { connect } from "react-redux";
import i18n from "../../../../../lib/i18n/i18n";
import { Field, reduxForm } from "redux-form";
import Toggle from "react-toggle";
import {
  Body,
  Section,
  Row,
  ToggleContainer,
  ToggleText,
} from "./providerDetails.styles";
import { update, deleteItem } from "../../../../../actions/providersActions";
import CreateButton from "../../../../UiComponents/Buttons/Default";
import SivanQuestionModal from "../../../../Modal/QuestionModal";
import InputWrappedWithField from "../../../../UiComponents/Inputs/DefaultWrappedWithField";
import NotesInput from "../../../../UiComponents/TextArea/Default";

const renderToggle = ({
  input,
  label,
  meta: { touched, error },
  type = "text",
}) => {
  const isHebrew = i18n.language === "he";
  const dir = isHebrew ? "rtl" : "ltr";
  return (
    <ToggleContainer isRtl={isHebrew}>
      <ToggleText>{label}</ToggleText>
      <Toggle checked={input.value} onChange={input.onChange} />
    </ToggleContainer>
  );
};

const FundingBodiesDetails = ({
  handleSubmit,
  update,
  providerData,
  deleteItem,
  closeModal,
}) => {
  const [isQuestionModalOpen, setIsQuestionModalOpen] = useState(false);

  const fundingBodyCreateAction = async (formValues) => {
    await update(formValues);
    closeModal();
  };

  const fundingBodyDeleteAction = async () => {
    setIsQuestionModalOpen(false);
    await deleteItem(providerData.id);
    closeModal();
  };

  return (
    <Body onSubmit={handleSubmit(fundingBodyCreateAction)}>
      <SivanQuestionModal
        titleText="מחיקה"
        bodySecondRow="גוף המימון ימחק לצמיתות"
        modalIsOpen={isQuestionModalOpen}
        closeModal={() => setIsQuestionModalOpen(false)}
        deleteItem={fundingBodyDeleteAction}
        isDelete
      />
      <Section basicData noBorder>
        <Row>
          <Field
            name="name"
            component={InputWrappedWithField}
            placeholder="שם"
            type="text"
          />
          <Field
            name="providerId"
            component={InputWrappedWithField}
            placeholder="ת.ז/ע.מ/ח.פ."
            type="number"
          />
          <Field
            name="address"
            component={InputWrappedWithField}
            placeholder="כתובת"
            type="text"
          />
          <Field
            name="city"
            component={InputWrappedWithField}
            placeholder="עיר"
            type="text"
          />
          <Field
            name="postalCode"
            component={InputWrappedWithField}
            placeholder="מיקוד"
            type="number"
          />
          <Field
            name="phoneNumber"
            component={InputWrappedWithField}
            placeholder="טלפון"
            type="text"
          />
        </Row>
        <Row>
          <Field
            name="email"
            component={InputWrappedWithField}
            placeholder="מייל"
            type="email"
          />
          <Field
            name="contactName"
            component={InputWrappedWithField}
            placeholder="איש קשר"
            type="text"
          />
          <Field name="notes" component={NotesInput} placeholder="הערות" />
          <Field
            name="openingBalance"
            component={InputWrappedWithField}
            placeholder="יתרת פתיחה"
            type="number"
          />
          <Field name="isActive" component={renderToggle} label="פעיל" />
        </Row>
      </Section>
      <CreateButton
        text="מחק"
        type="button"
        isDelete
        marginRight={2}
        onClick={() => setIsQuestionModalOpen(true)}
      />
      <CreateButton text="עדכן" type="submit" />
    </Body>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    initialValues: {
      ...ownProps.providerData,
    },
  };
}

export default connect(mapStateToProps, { update, deleteItem })(
  reduxForm({
    form: "UpdateFundingBodies",
  })(FundingBodiesDetails)
);
